<div class="calendar">
  <div class="calendar-header">
    @if (!showYearSelection) {
      <div class="month-display">
        <span (click)="toggleYearSelection()">{{ monthName }}</span>
        <div class="navigation-buttons">
          <span (click)="previousMonth()" class="arrow left">
            <app-icon iconName="chevron-left"></app-icon>
          </span>
          <span (click)="nextMonth()" class="arrow right">
            <app-icon iconName="chevron-right"></app-icon>
          </span>
        </div>
      </div>
      <div class="weekdays">
        @for (day of weekDays; track day) {
          <div>{{ day }}</div>
        }
      </div>
    }
  </div>
  @if (showYearSelection) {
    <div class="year-selection">
      <div class="year-selection__list">
        @for (y of years; track y) {
          <div class="year-selection__list__item" (click)="selectYear(y)" [id]="'year-' + y" [ngClass]="{ 'selected-year': y === currentMonth.getFullYear() }">
            {{ y }}
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="calendar-body">
      @for (day of monthDays; track day.date) {
        <div
          (click)="selectDay(day)"
          [ngClass]="{
            'current-month': day.isCurrentMonth,
            'adjacent-month': day.isAdjacentMonth || (!pastDatesSelection && day.date < today) || isInPreSelectedRange(day),
            'pre-selected': isPreSelectedDay(day),
            selected: isSelectedDay(day),
          }"
          class="day"
        >
          {{ day.date | date: 'd' }}
        </div>
      }
    </div>
  }

  <div class="calendar-footer">
    <button (click)="removeDate()" class="button button-small button-secondary button-full" translate>buttonComponent.Cancel</button>
    <!--    <button (click)="confirmDate()" class="button button-small button-primary button-full" translate>buttonComponent.done</button>-->
  </div>
</div>
